<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('pcgc')"
                        :isNewButton="true"
                        @new-button-click="newApplication"
                        :is-filter="false">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('pcgc')"
                              :isNewButton="true"
                              @new-button-click="newApplication"
                              :is-filter="false">
                </HeaderMobile>
            </template>
            <datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
                       :total="datatable.total" :queryParams="datatable.queryParams" :lineNumbers="false"
                       @on-page-change="onPageChange" @on-sort-change="onSortChange" @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
                       :title="$t('my_applications')"/>
        </app-layout>
    </div>
</template>
<script>

import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"

//Components
import DatatableFilter from "@/components/datatable/DatatableFilter"
import Datatable from "@/components/datatable/Datatable"
import {ValidationObserver, ValidationProvider} from "vee-validate"
import CommonModal from "@/components/elements/CommonModal"
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox"
import StaffAutoComplete from "@/components/interactive-fields/StaffAutoComplete"
import SelectDate from "@/components/interactive-fields/SelectDate"

//Services
import PcgcService from "@/services/PcgcService"

//Other
import qs from "qs"

//Pages




export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,

        DatatableFilter,
        Datatable,
        CommonModal,
        ValidationProvider,
        ValidationObserver,
        MultiSelectbox,
        StaffAutoComplete,
        SelectDate,
    },
    metaInfo() {
        return {
            title: this.$t("pcgc"),
        };
    },
    data() {
        return {
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: "",
                        field: "buttons",
                        html: true,
                        sortable: false,
                        tdClass: "p-0 text-center w-40 align-middle",
                        buttons: [
                            {
                                text: this.$t("cancel"),
                                class: "ri-delete-bin-2-line",
                                permission: "pdrmapplication_studentdelete",
                                callback: (row) => {
                                    this.appointmentCancelation(row)
                                },
                            },
                        ],
                    },
                    {
                        label: this.$t("id"),
                        field: "id",
                        sortable: false,
                        hidden: true,
                    },

                    {
                        label: this.$t("student_number"),
                        field: "student_number",
                        sortable: false,
                    },
                    {
                        label: this.$t("name"),
                        field: "student_name",
                        sortable: false,
                    },
                    {
                        label: this.$t("surname"),
                        field: "student_surname",
                        sortable: false,
                    },
                    {
                        label: this.$t("pcgc_application_datetime"),
                        field: "application_date",
                        sortable: false,
                        formatFn: (row, field) => {
                            if(row){
                                return row+' '+field.application_time.substring(0,5)
                            }
                        }
                    },
                    {
                        label: this.$t("pcgc_appointment_date"),
                        field: "appointment_date",
                        sortable: false,
                        formatFn: (row, field) => {
                            if(row){
                                return row+' '+field.appointment_time.substring(0,5)
                            }
                        }
                    },
                    {
                        label: this.$t("campus"),
                        field: "campus",
                        sortable: false,
                    },
                    {
                        label: this.$t("psychologist"),
                        field: "psychologist_name",
                        sortable: false,
                        formatFn: (row, field) => {
                            return row+' '+field.psychologist_surname
                        }
                    },
                    {
                        label: this.$t("application_status"),
                        field: this.getLocaleField('application_status'),
                        sortable: false,
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: "id",
                    page: 1,
                    limit: 20,
                },
            },

            appStatusOptions: [
                {
                    value: 'pending',
                    text: this.$t('pending'),
                }
            ],
            id: null,
            modalTitle: null,
            studentData: null
        }
    },

    created() {
        this.getRows()
    },

    methods: {
        filter() {
            this.datatable.queryParams.page = 1
            this.getRows()
        },
        filterClear() {
            this.datatable.queryParams.filter = {}
            this.getRows()
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage
            this.getRows()
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage
            this.datatable.queryParams.page = 1
            this.getRows()
        },
        onSortChange(params) {
            const sortType = params[0].type == "desc" ? "-" : ""
            this.datatable.queryParams.sort = sortType + params[0].field
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            this.$store.dispatch('auth/initUser')
            this.studentData = this.$store.getters['auth/getUser']
            this.datatable.queryParams.filter = {
                student_program_id: this.studentData.active_student_program.id
            }

            const config = {
                params: {
                    ...this.datatable.queryParams,
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false}),
            }

            PcgcService.getAllPcgcStudentApplications(config).then(response => {
                this.datatable.rows = response.data.data
                this.datatable.total = response.data.pagination.total
            }).finally(() => {
                this.datatable.isLoading = false;
            })
        },

        openModal(row, mode) {
            this.id = row.id
            this.modalTitle = mode
            this.$refs.updateModal.$refs.commonModal.show()
        },

        clearModal() {
            this.id = null
        },

        newApplication(){
            this.$router.push('/pcgc/application-form')
        },

        appointmentCancelation(data) {
            this.$swal.fire({
                    title: this.$t('confirmation'),
                    text: this.$t('pcgc_cancelation_info'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no'),
            }).then((result) => {
                if (result.isConfirmed) {
                    PcgcService.cancelStudentApplication(data.id).then(response => {
                        this.$toast.success(this.$t('api.'+response.data.message))
                        this.getRows()
                    }).catch((e) => {
                        this.showErrors(e, null)
                    })
                }
            })
        }

    },
};
</script>

